(() => {
 const calm = () => window.Shopify?.designMode || document.documentElement.dataset.bicaMotion === 'none' || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
 if (!customElements.get('bica-stage')) customElements.define('bica-stage', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort = new AbortController();
   this.buttons = [...this.querySelectorAll('[data-stage-tab]')];
   this.panels = [...this.querySelectorAll('[data-stage-panel]')];
   if (!this.buttons.length) return;
   this.querySelector('[data-stage-controls]').hidden = false;
   this.buttons.forEach((button,index) => {
    button.addEventListener('click',()=>this.select(index),{signal:this.abort.signal});
    button.addEventListener('keydown',event=>{
     const rtl=getComputedStyle(this).direction==='rtl';
     let next;
     if(event.key==='Home') next=0;
     if(event.key==='End') next=this.buttons.length-1;
     if(event.key==='ArrowRight') next=(index+(rtl?-1:1)+this.buttons.length)%this.buttons.length;
     if(event.key==='ArrowLeft') next=(index+(rtl?1:-1)+this.buttons.length)%this.buttons.length;
     if(next!==undefined){event.preventDefault();this.select(next);this.buttons[next].focus();}
    },{signal:this.abort.signal});
   });
   this.addEventListener('shopify:block:select',event=>{
    const index=this.panels.findIndex(panel=>panel.dataset.blockId===event.detail?.blockId);
    if(index>=0)this.select(index);
   },{signal:this.abort.signal});
   this.select(0,false);
  }
  select(index,animate=true) {
   this.buttons.forEach((button,i)=>{button.setAttribute('aria-selected',String(i===index));button.tabIndex=i===index?0:-1;});
   this.panels.forEach((panel,i)=>{
    panel.hidden=i!==index;
    if(i===index){
     panel.setAttribute('role','tabpanel');
     panel.setAttribute('aria-labelledby',this.buttons[i].id);
     this.style.setProperty('--stage-accent',panel.dataset.accent);
     this.querySelector('[data-stage-number]').textContent=String(index+1).padStart(2,'0');
     if(animate&&!calm())panel.animate?.([{opacity:.5,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:280,easing:'ease-out'});
    }
   });
  }
  disconnectedCallback(){this.abort?.abort();}
 });
 if (!customElements.get('bica-comparison')) customElements.define('bica-comparison', class extends HTMLElement {
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();
   this.selects=[...this.querySelectorAll('[data-compare-select]')];
   this.templates=[...this.querySelectorAll('template[data-comparison]')];
   if(this.templates.length<2)return;
   this.querySelector('[data-compare-controls]').hidden=false;
   this.selects.forEach((select,i)=>select.addEventListener('change',()=>this.update(i),{signal:this.abort.signal}));
   this.update(-1);
  }
  update(changed){
   if(this.selects[0].value===this.selects[1].value){
    const other=changed===0?1:0;
    this.selects[other].value=this.templates.find(t=>t.dataset.comparison!==this.selects[1-other].value).dataset.comparison;
   }
   this.querySelectorAll('[data-compare-slot]').forEach((slot,i)=>{
    const template=this.templates.find(t=>t.dataset.comparison===this.selects[i].value);
    slot.replaceChildren(template.content.cloneNode(true));
   });
   if(changed>=0&&!calm())this.querySelectorAll('[data-compare-slot]').forEach(slot=>slot.animate?.([{opacity:.6,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:240,easing:'ease-out'}));
   if(changed>=0)this.querySelector('[data-compare-status]').textContent=`تقارن الآن: ${this.selects.map(s=>s.selectedOptions[0].textContent.trim()).join(' و ')}`;
  }
  disconnectedCallback(){this.abort?.abort();}
 });
})();
